import { Section } from "@bmi-digital/components";
import Tabs from "@bmi-digital/components/tabs";
import { styled } from "@mui/material/styles";

export const StyledSDPTabLeadBlock = styled(Tabs)(({ theme }) => ({
  background: theme.colours.white,
  ":global": {
    "[class*='MuiBox-root']": {
      paddingTop: "0"
    },
    "[class*='Section-module']": {
      [theme.breakpoints.down("xl")]: {
        paddingTop: "48px"
      }
    },
    "[class*='MuiGrid2-root']": {
      marginTop: "0",
      paddingTop: "0",
      paddingBottom: "0"
    },
    "[class*='TabsBar'] [class*='MuiContainer-root']": {
      [theme.breakpoints.down("xl")]: {
        paddingLeft: "24px",
        paddingRight: "24px"
      }
    }
  }
}));

export const StyledTabPanel = styled(Tabs.TabPanel)(({ theme }) => ({
  "&.Tabs-tabPanelBox": { padding: 0 }
}));

export const StyledSection = styled(Section)({
  "&.Section-root": {
    padding: 0
  }
});
